import React from "react";

export default function header () {
  return (
    <header>
      <div>FEEDBACK-LAB1</div>
    </header>
  )
}
